module.exports = __webpack_public_path__ + "static/media/image7.7d2547e1.png";